import { gql as apolloGql } from "@apollo/client";

/**
 * Convert a GraphQL document string (for example, from @devforce/trailhead-client-gql)
 * into an Apollo DocumentNode.
 *
 * @param {string} documentString - GraphQL query/mutation/fragment as a string
 * @returns {import("@apollo/client").DocumentNode}
 */
export function gqlFromString(documentString) {
  return apolloGql`
    ${documentString}
  `;
}
